import React from 'react';
import styled from 'styled-components';

import { StyledOption } from '../../Common/Selector';
import DatePicker, { StyledButton } from '../../../DatePicker';

const StyledDatePicker = styled(DatePicker)`
  ${StyledButton} {
    background-color: transparent;
    border: 1px solid #e6e9ee;
    border-radius: 4px;
    height: 43px;
  }

  ${StyledOption} {
    padding: 3px 10px 7px 10px;
  }
`;

export interface TicketFilterByDateProps {
  className?: string;
  name?: string;
  value: [Date, Date] | null;
  onChange: ({
    name,
    value,
  }: {
    name: TicketFilterByDateProps['name'];
    value: TicketFilterByDateProps['value'];
  }) => void;
}

class TicketFilterByDate extends React.PureComponent<TicketFilterByDateProps> {
  static defaultProps = {
    className: '',
    name: '',
    onChange: Function.prototype,
    value: null,
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    const { onChange, name } = this.props;
    onChange({ name, value });
  }

  render() {
    const { value, ...props } = this.props;

    return (
      <StyledDatePicker
        {...props}
        multiple
        required={false}
        value={value}
        dateFormat="d MMMM"
        onChange={this.handleChange}
      />
    );
  }
}

export default TicketFilterByDate;
